<template>
  <el-card shadow="hover" class="page-tabel">
    <!-- 按钮 S -->
    <el-row class="handle-box" type="flex">
      <!-- <el-col :span="13"> -->
        <el-button type="primary" @click="add"
                   v-if="btns.indexOf('add') !== -1"
                   :disabled="$has(permission + 'Add') || !hasAuthority">{{addBtnTitle}}</el-button>
        <el-button type="danger" @click="deletSelect(multipleSelection.join(','))"
                   v-if="btns.indexOf('deletSelect') !== -1"
                   :disabled="$has(permission + 'Delete') || multipleSelection.length === 0">删除</el-button>
        <el-button v-if="graduate" @click="graduate(multipleSelection.join(','))"
                   :disabled="$has('studentListGraduate') || multipleSelection.length === 0">毕业</el-button>
        <template>
          <slot name="custom-buttons" :multipleSelection="multipleSelection"></slot>
        </template>
      <!-- </el-col> -->
      <!-- <el-row :span="5" :gutter="12" type="flex" justify="end"> -->
        <template>
          <slot name="custom-buttons_right"></slot>
        </template>
        <el-col :span="12" v-if="btns.indexOf('improt') !== -1">
          <el-button @click="importVisible = true">导入</el-button>
        </el-col>
        <!-- <el-col v-if="btns.indexOf('export') !== -1"> -->
          <!-- <el-button type="primary" @click="exprotExcel"
                     :disabled="$has(permission + 'Export')">导出</el-button> -->
          <!-- <el-button @click="exprotExcel">{{exportBtnTitle}}</el-button>
        </el-col> -->
        <!-- <el-col v-if="btns.indexOf('export') !== -1">
          <el-button @click="exprotExcel">{{exportBtnTitle}}</el-button>
        </el-col> -->
        <el-button v-if="btns.indexOf('export') !== -1" @click="exprotExcel">{{exportBtnTitle}}</el-button>
      </el-row>
    <!-- </el-row> -->
    <!-- 按钮 S -->
    <!-- 导入 S -->
    <el-dialog title="导入" :visible.sync="importVisible" width="40%" :before-close="closeImport">
      <el-row class="import-box">
        <!-- <el-col :gutter="12" type="flex" justify="space-between">
          <el-col>
            <span>导入数据前需要先下载数据模板按照模板需要求填写相关信息</span>
          </el-col>
          <el-col :span="5">{{improtExel && improtExel.tempName}}模板</el-col>
          <el-col :span="6">
            <el-button type="text" @click="downLoadTem">下载模板</el-button>
          </el-col>
        </el-col> -->
        <el-col>
          <upload-file :ref-obj.sync="refs"
                       :fileList="fileList"
                       :limit="1"
                       :autoUpload="false"></upload-file>
        </el-col>
        <!-- <el-col>
          <el-radio v-model="isCover" label="1">重复不覆盖</el-radio>
          <el-radio v-model="isCover" label="2">重复覆盖</el-radio>
        </el-col> -->
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeImport">取 消</el-button>
        <el-button type="primary" @click="save">保 存</el-button>
      </div>
    </el-dialog>
    <!-- 导入 E -->
    <!-- 列表 S -->
    <!-- :height="tableHeight - 294" -->
    <el-table
      ref="table"
      class="table"
      :data="list.rows"
      :max-height="maxHeight"
      @selection-change="handleSelectionChange"
      style="width: 100%"
      :row-key="rowKey"
      :border="true">
      <el-table-column
        label="序号"
        type="index"
        align="center"
        :reserve-selection="reserveSelection"
        width="60">
      </el-table-column>
      <el-table-column
        v-if="selection"
        fixed
        :reserve-selection="reserveSelection"
        type="selection"
        :selectable="selectable"
        width="55"
        align="center">
      </el-table-column>
      <el-table-column
        v-for="(item, index) in fieldList"
        v-bind:key="index"
        :prop="item.prop"
        :label="item.label"
        :fixed="item.fixed ? item.fixed : false"
        :reserve-selection="reserveSelection"
        :width="item.width"
        :align="item.align">
        <template slot-scope="scope">
          <slot v-if="item.type === 'slot'"
                :name="'col-' + item.prop"
                :row="scope.row"
                :index="scope.$index"
          />
          <img :src="scope.row[item.prop].attachUrl" alt=""
               v-else-if="item.type === 'img' && scope.row[item.prop]" class="icon">
          <span v-else-if="item.type === 'img' && !scope.row[item.prop]">无</span>
          <span v-else>
            {{scope.row[item.prop] ? scope.row[item.prop] : '-'}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="btns.indexOf('handle') !== -1"
        fixed="right"
        label="操作"
        :width="handelWidth"
        align="center">
        <template slot-scope="scope">
          <el-row :guttar="12" type="flex" justify="space-around">
            <el-col v-if="handleSlot" style="display: flex; align-items: center;">
              <slot name="handleSlot" :row="scope.row"
                    :index="scope.$index"/>
            </el-col>
            <el-col :span="3" v-if="btns.indexOf('edit') !== -1">
              <el-button type="text" @click="edit(scope.$index, scope.row)" :disabled="$has(permission + 'Edit')"><i class="el-icon-edit-outline"></i></el-button>
            </el-col>
            <el-col :span="3"  v-if="btns.indexOf('copy') !== -1">
              <el-button type="text" @click="add(scope.$index, scope.row)"
                         :disabled="$has(permission + 'Add')"><i class="el-icon-document-copy"></i></el-button>
            </el-col>
            <el-col :span="3" v-if="btns.indexOf('delet') !== -1">
              <el-button type="text" @click="delet(scope.$index, scope.row)"
                         :disabled="$has(permission + 'Delete')"><i class="el-icon-delete"></i></el-button>
            </el-col>
            <el-col :span="3" v-if="btns.indexOf('view') !== -1">
              <el-button type="text" @click="view(scope.$index, scope.row)"
                         :disabled="$has(permission + 'View')"><i class="el-icon-view"></i></el-button>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <!-- 列表 E -->
    <!-- 分页 S -->
    <el-row v-if="page" type="flex" justify="end" class="page-component">
      <div style="color:grey;flex-grow:1;padding-left:50px" v-if="tips">{{tips}}</div>
      <el-pagination
        @size-change="(size) => refresh(pageNum, size)"
        @current-change="(page) => refresh(pageNum, size)"
        :current-page.sync="pageNum"
        :page-size="size"
        layout="sizes, prev, pager, next"
        :total="list.total">
      </el-pagination>
    </el-row>
    <!-- 分页 E -->
  </el-card>
</template>

<script>
import uploadFile from '../UploadFile'
import userData from '../../store/userData/index'
import Sortable from 'sortablejs'
export default {
  name: 'tree',
  data () {
    return {
      multipleSelection: [],
      importVisible: false,
      fileList: [],
      refs: null,
      isCover: '1',
      loading: null,
      tableHeight: null,
      pageNum: 1
    }
  },
  components: {
    uploadFile
  },
  // 传值参数
  props: {
    // 功能
    btns: {
      type: Array,
      default: () => {
        return []
      }
    },
    /*
    * 新增
    * */
    add: {
      type: Function
    },
    addBtnTitle: {
      type: String,
      default: '新增'
    },
    /*
    * 编辑
    * */
    edit: {
      type: Function
    },
    // 是否多选
    selection: {
      type: Boolean
    },
    /*
    * 删除
    * */
    deletSelect: {
      type: Function
    },
    delet: {
      type: Function
    },
    deleteName: {
      type: String
    },
    /*
    * 查看
    * */
    view: {
      type: Function
    },
    /*
    * 导入
    * */
    improtExel: {
      type: Object
    },
    toImport: {
      type: Function
    },
    /*
    * 导出
    * */
    exprot: {
      type: String
    },
    exportBtnTitle: {
      type: String,
      default: '导出'
    },
    // 毕业按钮
    graduate: {
      graduate: Boolean
    },
    /*
    * 列表
    * */
    list: {
      type: Object | Array
    },
    fieldList: {
      type: Array
    },
    /**
     * selection 是否可以勾选
     */
    selectable: {
      type: Function
    },
    /**
     * 表格高度
     */
    maxHeight: {
      type: String,
      default: 'auto'
    },
    /*
    * 操作栏
    * */
    // 宽度
    handelWidth: {
      type: String,
      default: '130'
    },
    // 插槽
    handleSlot: {
      type: Boolean
    },
    // 权限
    permission: {
      type: String
    },
    // 仓库名称下拉框权限
    hasAuthority: {
      type: Boolean,
      default: true
    },
    /*
    * 分页
    * */
    page: {
      type: Number
    },
    size: {
      type: Number
    },
    refresh: {
      type: Function
    },
    /*
    * 拖拽
    * */
    isDrop: {
      type: Boolean
    },
    getDropResult: {
      type: Function
    },
    noDragIndex: {
      type: String
    },
    selectionChange: {
      type: Function,
      default: null
    },
    reserveSelection: {
      type: Boolean,
      default: false
    },
    rowKey: {
      type: String,
      default: ''
    },
    // 左下角提示、备注内容
    tips: {
      type: String
    }

    // 'border'
  }, // 接收父组件的方法
  computed: {
    exportMark () {
      return userData.state.exportMark
    }
  },
  watch: {
    page: {
      deep: true,
      handler (val) {
        this.pageNum = val
      }
    },
    exportMark: {
      deep: true,
      handler (val) {
        if (val === 1) {
          this.closeImport()
          this.refresh(this.pageNum, this.size)
          userData.state.exportMark = 0
          this.loading.close()
        }
      }
    },
    'list.rows': {
      deep: true,
      handler (val) {
        // console.log(val, 'val')
        if (this.isDrop && val) {
          this.rowDrop()
          setTimeout(() => {
            const tbody = document.querySelectorAll('.el-table__body-wrapper tbody')
            if (this.noDragIndex && tbody[0].childNodes[val.length - 1]) {
              tbody[0].childNodes[this.noDragIndex].classList.add('no-drag')
            }
          }, 500)
        }
      }
    }
  },
  mounted () {
    if (this.$refs.table) {
      // console.log(this.$refs.table)
      this.$emit('update:refObj', this.$refs.table)
    }
    // 是否拖拽
    if (this.isDrop && this.list.rows) {
      this.rowDrop()
      setTimeout(() => {
        const tbody = document.querySelectorAll('.el-table__body-wrapper tbody')
        if (this.noDragIndex && tbody[0].childNodes[this.list.rows.length - 1]) {
          tbody[0].childNodes[this.noDragIndex].classList.add('no-drag')
        }
      }, 500)
    }

    this.tableHeight = window.document.body.clientHeight
  },
  methods: {
    handleSelectionChange (val) {
      this.multipleSelection = val.map(ele => {
        return ele[this.deleteName]
      })
      if (this.selectionChange) {
        this.selectionChange(val)
      }
    },
    // 导出
    exprotExcel () {
      if (this.exprot.indexOf('?') === -1) {
        location.href = this.$global.httpBaseURL + '/api' + this.exprot + '?TOKEN_KEY=' + localStorage.getItem('token')
      } else {
        location.href = this.$global.httpBaseURL + '/api' + this.exprot + '&TOKEN_KEY=' + localStorage.getItem('token')
      }
    },
    /*
    * 导入
    * */
    // 下载模版
    downLoadTem () {
      location.href = this.$global.httpBaseURL + '/api' + this.improtExel.downLoadTempPath + '?TOKEN_KEY=' + localStorage.getItem('token')
    },
    // 确定导入
    save () {
      if (this.refs.uploadFiles[0]) {
        this.toImport(this.refs.uploadFiles[0].raw, this.isCover)
        // this.loading = this.$loading({
        //   lock: true,
        //   text: 'Loading',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.7)'
        // })
      } else {
        this.$message({
          showClose: true,
          message: '请上传文件',
          type: 'error'
        })
      }
    },
    // 取消导入
    closeImport () {
      this.fileList = []
      this.importVisible = false
      this.isCover = '1'
    },
    // 排序
    rowDrop () {
      const tbody = document.querySelectorAll('.el-table__body-wrapper tbody')
      tbody.forEach((v, i) => {
        Sortable.create(v, {
          dataIdAttr: 'data-id',
          animation: 150,
          filter: '.no-drag',
          preventOnFilter: false,
          // 拖动完成回调
          onEnd: ({ newIndex, oldIndex }) => {
            if (newIndex !== oldIndex) {
              // 是否拖动
              let list = this.list.rows
              let newArray = list
              this.list.rows.splice(newIndex, 0, list.splice(oldIndex, 1)[0])
              newArray = list.slice(0)
              this.list.rows = []
              this.$nextTick(() => {
                this.list.rows = newArray
              })
              this.getDropResult(this.$refs.table.tableData)
            }
          }
        })
      })
    }
  }
}
</script>

<style scoped>
  .import-box .el-button.el-button--text {
    font-size: 14px !important;
    padding: 0;
  }

  .import-box > .el-col {
    padding: 20px 0;
    border-bottom: 1px solid #e9e9e9;
  }

  .import-box > .el-col:last-child {
    border: none;
  }

  .el-table__row .el-input {
    width: 100% !important;
  }

  >>>.no-drag:hover {
    cursor: unset !important;
  }

  .page-tabel .icon {
    width: 50px;
    height: 50px;
  }
  >>> .el-table td {
    /* padding: 3px 0; */
  }
  >>> input[type=number] {
      -moz-appearance:textfield;
  }
  >>> input[type=number]::-webkit-inner-spin-button,
  >>> input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Table/Index.vue